<template>
<div>
  <b-card no-body class="mb-1">
    <b-card-header header-tag="header" class="p-0 mt-1">
      <b-btn block href="#" v-b-toggle.bondPricing variant="info" class="text-left">{{bondName}}, {{dealName}} - Bond Pricing</b-btn>
      <p v-if="this.$store.getters.isAdmin && this.runTime != 0">Run time: {{this.runTime}}ms </p>
    </b-card-header>
      <b-collapse id="bondPricing" visible>
        <b-tabs card>
          <b-tab @click="clearErrorMessage()" title="Price" :active="$route.query.price ? false : true">
            <b-row>
              <b-col cols="4">
                <settings
                  :showPriceSettings="true"
                  :inputYield="inputYield"
                  :inputSpread="inputSpread"
                  :inputRefCurve="refCurve"
                  @yieldChange="inputYield = $event"
                  @spreadChange="inputSpread = $event"
                  @refCurveChange="refCurve = $event" />
                <buttons
                  @runSingle="runPrice(true)"
                  @runMatrix="runPrice(false)" />
                <b-row>
                  <b-alert v-if="this.errorMessage" variant="danger" class="float-left" show>{{this.errorMessage}}</b-alert>
                </b-row>
                <SingleScenarioResult
                  caption="Bond"
                  type="Price"
                  :result="singlePrice"
                  :wal="wal"
                  :principalWindow="principalWindow"
                  :writedownPct="writedownPct"
                  :firstLossPeriod="firstLossPeriod" />
              </b-col>
              <b-col cols="8">
                <b-tabs>
                  <b-tab @click="clearErrorMessage()" title="Price" active>
                    <matrix :matrixName="'Price'" :matrixUnits="'$'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="priceMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames"/>
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="WAL">
                    <matrix :matrixName="'WAL'" :matrixUnits="'years'" :matrixType="'price'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="walMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="Write Down">
                    <matrix :matrixName="'Write Down'" :matrixUnits="'%'" :matrixType="'price'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="writeDownMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2 ml-0">
              <b-btn v-if="bondCashflow && bondCashflow.BondCashflow && bondCashflow.BondCashflow.length > 0" variant="info" class="float-left" @click="exportCashflowToExcel()">Export Cashflow to Excel</b-btn>
            </b-row>
            <bond-cashflow :bond="bondCashflow" v-if="bondCashflow && bondCashflow.BondCashflow && bondCashflow.BondCashflow != undefined"
              :miscVariables="miscVariables"
              :isMatrixClicked="matrixCellClicked"
              :cpr="cprToPass"
              :cdr="cdrToPass" />
          </b-tab>
          <b-tab @click="clearErrorMessage()" title="Yield" :active="$route.query.price ? true : false">
            <b-row>
              <b-col cols="4">
                <settings
                  :showYieldSettings="true"
                  :inputPrice="inputPrice"
                  @priceChange="inputPrice = $event" />
                <buttons
                  @runSingle="runYield(true)"
                  @runMatrix="runYield(false)" />
                <b-row>
                  <b-alert v-if="this.errorMessage" variant="danger" class="float-left" show>{{this.errorMessage}}</b-alert>
                </b-row>
                <SingleScenarioResult
                  caption="Bond"
                  type="Yield"
                  :result="singleYield"
                  :wal="wal"
                  :principalWindow="principalWindow"
                  :writedownPct="writedownPct"
                  :firstLossPeriod="firstLossPeriod" />
              </b-col>
              <b-col cols="8">
                <b-tabs>
                  <b-tab @click="clearErrorMessage()" title="Yield" active>
                    <matrix
                      :matrixName="'Yield'" :matrixUnits="'%'" :cpr="matrixCpr" :cdr="matrixCdr"
                        :matrix="yieldMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="WAL">
                    <matrix :matrixName="'WAL'" :matrixUnits="'years'" :matrixType="'yield'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="walMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="Write Down">
                    <matrix :matrixName="'Write Down'" :matrixUnits="'%'" :matrixType="'yield'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="writeDownMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2 ml-0">
              <b-btn v-if="bondCashflow && bondCashflow.BondCashflow  && bondCashflow.BondCashflow.length > 0" variant="info" class="float-left" @click="exportCashflowToExcel()">Export Cashflow to Excel</b-btn>
            </b-row>
            <bond-cashflow :bond="bondCashflow" v-if="bondCashflow.BondCashflow != undefined"
              :miscVariables="miscVariables"
              :isMatrixClicked="matrixCellClicked"
              :cpr="cprToPass"
              :cdr="cdrToPass" />
          </b-tab>
          <b-tab @click="clearErrorMessage()" title="Spread">
            <b-row>
              <b-col cols="4">
                <settings
                  :showSpreadSettings="true"
                  :inputPrice="inputPrice"
                  :inputRefCurve="refCurve"
                  @priceChange="inputPrice = $event"
                  @refCurveChange="refCurve = $event" />
                <buttons
                  @runSingle="runSpread(true)"
                  @runMatrix="runSpread(false)" />
                <b-row>
                  <b-alert v-if="this.errorMessage" variant="danger" class="float-left" show>{{this.errorMessage}}</b-alert>
                </b-row>
                <SingleScenarioResult
                  caption="Bond"
                  type="Spread"
                  :result="singleSpread"
                  :wal="wal"
                  :principalWindow="principalWindow"
                  :writedownPct="writedownPct"
                  :firstLossPeriod="firstLossPeriod" />
              </b-col>
              <b-col cols="8">
                <b-tabs>
                  <b-tab @click="clearErrorMessage()" title="Spread" active>
                    <matrix
                    :matrixName="'Spread'"
                    :matrixUnits="'bp'"
                    :cpr="matrixCpr"
                    :cdr="matrixCdr"
                    :matrix="spreadMatrix"
                    @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="WAL">
                    <matrix :matrixName="'WAL'" :matrixUnits="'years'" :matrixType="'spread'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="walMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                  <b-tab @click="clearErrorMessage()" title="Write Down">
                    <matrix :matrixName="'Write Down'" :matrixUnits="'%'" :matrixType="'spread'" :cpr="matrixCpr" :cdr="matrixCdr"
                      :matrix="writeDownMatrix" @matrixCellClicked="onMatrixCellClicked" :vectors="vectorNames" />
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
            <b-row class="mb-2 mt-2 ml-0">
              <b-btn v-if="bondCashflow && bondCashflow.BondCashflow  && bondCashflow.BondCashflow.length > 0" variant="info" class="float-left" @click="exportCashflowToExcel()">Export Cashflow to Excel</b-btn>
            </b-row>
            <bond-cashflow ref="cashflow" :bond="bondCashflow" v-if="bondCashflow.BondCashflow != undefined"
              :miscVariables="miscVariables"
              :isMatrixClicked="matrixCellClicked"
              :cpr="cprToPass"
              :cdr="cdrToPass" />
          </b-tab>
        </b-tabs>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import service from '../../services/HttpRequestService';
import formatter from '../../utilities/Formatter';
import { isNotEmpty2dArray, createEmpty2dArray } from '../../utilities/ArrayUtils';
import { isNumericArrayValid, convertToPctArray, stringToArray } from '../../utilities/ArrayUtils';
import moment from 'moment';
import Datepicker from 'vue2-datepicker';
import DealCatalog from '../dealCatalog';
import SingleScenarioResult from '../SingleScenarioResult';
import Matrix from '../Matrix';
import Settings from './Settings';
import Buttons from './Buttons';
import {
  isBasicAnalysisBodyValid,
  isSingleValueValid,
  createBasicValidationErrorMessage
} from '../../validators/inputValidator';
import RequestBodyFactory from '../../services/RequestBodyFactory';
import BondCashflow from '../dealAnalysis/BondCashflow';
import { loadValuesFromVector, prepareScenarioVectors } from '../../utilities/SimulationVectors';
import Scenario from '../scenario/Scenario';
import excelSupport from '../../utilities/ExcelSupport';
import { TRACE_ERROR } from '../../constants';

export default {
  props: [
    'dealName',
    'bondName',
    'settlementDate',
    'cpr',
    'cdr',
    'lossSeverity',
    'delinquency',
    'libor',
    'hpi',
    'NationalUnemploymentForecast',
    'hpa',
    'twoYrTsy',
    'tenYrTsy',
    'tuneCpr',
    'tuneCdr',
    'tuneSeverity',
    'mtg15Yr',
    'mtg30Yr',
    'selectedScenario'
  ],

  data() {
    return {
      inputPrice: 100,
      inputYield: [0],
      inputSpread: 0,
      refCurve: [],
      priceMatrix: [[]],
      yieldMatrix: [[]],
      spreadMatrix: [[]],
      walMatrix: [[]],
      writeDownMatrix: [[]],
      matrixCpr: [],
      matrixCdr: [],
      errorMessage: '',
      singlePrice: '',
      singleYield: '',
      singleSpread: '',
      wal: '',
      principalWindow: '',
      writedownPct: '',
      firstLossPeriod: '',
      forceUpdate: false,
      bondCashflow: {},
      matrixCellClicked: false,
      cprToPass: 0,
      cdrToPass: 0,
      runTime: 0,
      runDate: null,
      vectors: new Map(),
      vectorNames: [],
      miscVariables: []
    };
  },
  async created() {
    setDataFromCookies(this);
    setDataFromAppData(this);
    let urlPrice = this.$route.query.price;
    if (urlPrice) {
      this.inputPrice = urlPrice;
    }
    let res = await service.getUserVectors();
    if (res.status == 200) {
      let vectors = res.data;
      for (let vector of vectors) {
        this.vectors.set(vector.Name, vector.Value.join(','));
        this.vectorNames.push(vector.Name);
      }
    }
  },

  watch: {
    bondName(newVal) {
      if (this.$store.getters.bondName != newVal) {
        this.$root.$data.clearBondAnalysisSingleResults();
        this.$root.$data.clearBondAnalysisMatrixResults();
        setDataFromAppData(this);
      }
      this.$store.commit('setBondName', newVal);
    }
  },
  methods: {
    async runPrice(isSingle, cpr = null, cdr = null) {
      this.errorMessage = '';
      if (
        isNumericArrayValid(stringToArray(this.inputYield)) ||
        (isSingleValueValid(this.inputSpread) && isNumericArrayValid(stringToArray(this.refCurve)))
      ) {
        let specBody = {
          Yield: this.inputYield.length ? convertToPctArray(this.inputYield, false) : null,
          ReferenceCurve: convertToPctArray(this.refCurve, false),
          Spread: this.inputSpread
        };
        if (isSingle) {
          this.runSingleCalculation('Price', cpr, cdr, specBody);
        } else {
          this.runMatrixCalculation('Price', specBody);
        }
      } else {
        this.errorMessage = 'Either Yield or both Spread and Benchmark Rate are required.';
      }
    },

    async runYield(isSingle, cpr = null, cdr = null) {
      this.errorMessage = '';
      if (isSingleValueValid(this.inputPrice)) {
        if (isSingle) {
          this.runSingleCalculation('Yield', cpr, cdr, { Price: this.inputPrice });
        } else {
          this.runMatrixCalculation('Yield', { Price: this.inputPrice });
        }
      } else {
        this.errorMessage = 'Price is required.';
      }
    },

    async runSpread(isSingle, cpr = null, cdr = null) {
      this.errorMessage = '';
      if (
        isSingleValueValid(this.inputPrice) &&
        isNumericArrayValid(stringToArray(this.refCurve))
      ) {
        if (isSingle) {
          this.runSingleCalculation('Spread', cpr, cdr, {
            Price: this.inputPrice,
            ReferenceCurve: convertToPctArray(this.refCurve, false)
          });
        } else {
          this.runMatrixCalculation('Spread', {
            Price: this.inputPrice,
            ReferenceCurve: convertToPctArray(this.refCurve, false)
          });
        }
      } else {
        this.errorMessage = ' Price and Benchmark Rate are required.';
      }
    },

    onMatrixCellClicked(payload) {
      let { type, cpr, cdr } = payload;
      this.matrixCellClicked = true;

      this.cprToPass = cpr;
      this.cdrToPass = cdr;

      const regex = RegExp('.*[a-zA-Z]+.*');
      if (typeof cpr === 'string' && regex.test(cpr)) {
        if (this.vectors.has(cpr)) {
          cpr = this.vectors.get(cpr);
        } else {
          this.errorMessage = cpr + ' vector was not found.';
          return;
        }
      }
      if (typeof cdr === 'string' && regex.test(cdr)) {
        if (this.vectors.has(cdr)) {
          cdr = this.vectors.get(cdr);
        } else {
          this.errorMessage = cdr + ' vector was not found.';
          return;
        }
      }

      if (type == 'price') {
        this.runPrice(true, cpr, cdr);
      } else if (type == 'yield') {
        this.runYield(true, cpr, cdr);
      } else if (type == 'spread') {
        this.runSpread(true, cpr, cdr);
      }
    },

    async runSingleCalculation(type, cpr, cdr, specBody) {
      if (cpr == null && cdr == null) {
        this.matrixCellClicked = false;
      }
      let singleField = 'single' + type;
      try {
        let body = new RequestBodyFactory('BOND', {
          dealName: this.dealName,
          bondName: this.bondName,
          settlementDate: this.settlementDate,
          libor: this.libor,
          runLoanLevel: this.$store.getters.useLoanLevel,
          prepaymentModel: this.$store.getters.prepaymentModel,
          cpr: cpr || this.cpr,
          cdr: cdr || this.cdr,
          lossSeverity: this.lossSeverity,
          delinquency: this.delinquency,
          hpi: this.hpi,
          NationalUnemploymentForecast: this.NationalUnemploymentForecast,
          hpa: this.hpa,
          twoYrTsy: this.twoYrTsy,
          tenYrTsy: this.tenYrTsy,
          tuneCpr: this.tuneCpr,
          tuneCdr: this.tuneCdr,
          tuneSeverity: this.tuneSeverity,
          mtg15: this.mtg15Yr,
          mtg30: this.mtg30Yr,
          selectedScenario: this.selectedScenario,
          specBody: specBody,
          cleanupCall: this.$store.getters.cleanupCall
        });

        setCookies(this);
        this.$emit('show-spinner');

        if (body.PrepaymentModel == 'UserDefined' && !isBasicAnalysisBodyValid(body)) {
          this.errorMessage = createBasicValidationErrorMessage(
            body.Cpr,
            body.Cdr,
            body.LossSeverity,
            body.Delinquency,
            body.Libor
          );
          return;
        }

        var res = await service.runPiceYieldSpread(type, body, this.$store.getters.useLoanLevel);
        this.runDate = new Date();
        let bondCashflow = res.data.Simulation.BondsCashflows.filter(
          cashflow => cashflow.BondName == this.bondName
        )[0];

        for (let i = 0; i < bondCashflow.BondCashflow.length; i++) {
          bondCashflow.BondCashflow[i] = formatter.formatDateValues(bondCashflow.BondCashflow[i], [
            'PaymentDate'
          ]);
          bondCashflow.BondCashflow[i] = formatter.formatDollarValues(
            bondCashflow.BondCashflow[i],
            ['Balance', 'Principal', 'Interest', 'Cash', 'ActualWriteDown']
          );
          bondCashflow.BondCashflow[i] = formatter.formatPctValues(bondCashflow.BondCashflow[i], [
            'Rate',
            'CprRate',
            'CdrRate',
            'LossSeverityRate',
            'DelinquencyRate'
          ]);
          if (i > 0 && bondCashflow.BondCashflow[i - 1]['Balance'] < 0.005) {
            bondCashflow.BondCashflow = bondCashflow.BondCashflow.slice(0, i);
            break;
          }
        }
        this.bondCashflow = bondCashflow;

        this.miscVariables = res.data.Simulation.MiscVariables;

        if (res.data[type].IsSuccessful) {
          let formatFunction = null;
          switch (type) {
            case 'Price':
              formatFunction = val => formatter.formatDollarValue(val, 5);
              break;
            case 'Yield':
              formatFunction = val => formatter.formatPctValue(val);
              break;
            case 'Spread':
              formatFunction = val => formatter.round(val);
              break;
          }
          this[singleField] = formatFunction(res.data[type].Value);
        } else {
          this[singleField] = '-----';
          // TODO sk: remove after redesigning c++ message system
          if (
            res.data[type].ErrorMessage !== "Can't compute Yield." &&
            res.data[type].ErrorMessage !== 'Too many tries in Yield calculation.' &&
            res.data[type].ErrorMessage !== 'Guess is too negative in Yield calculation.' &&
            res.data[type].ErrorMessage !== "Can't compute Spread." &&
            res.data[type].ErrorMessage !== 'Too many tries in Spread calculation.'
          ) {
            this.errorMessage = res.data[type].ErrorMessage;
          }
        }

        this.wal = bondCashflow.Wal != null ? formatter.round(bondCashflow.Wal) : '-----';
        this.principalWindow = formatter.formatDashesIfNeeded(bondCashflow.PrincipalWindow);
        this.writedownPct =
          bondCashflow.WritedownPct != null
            ? formatter.formatPctValue(bondCashflow.WritedownPct)
            : '-----';
        this.firstLossPeriod = bondCashflow.FirstLossPeriod;
      } catch (err) {
        this[singleField] = '';
        this.errorMessage = err.response.data.Message;
        await service.log(TRACE_ERROR, this.errorMessage, err.stack);
      } finally {
        this.$root.$data.setBondAnalysisSingleResults(
          this.singlePrice,
          this.singleYield,
          this.singleSpread,
          this.wal,
          this.principalWindow,
          this.writedownPct,
          this.firstLossPeriod,
          this.bondCashflow
        );
        this.$emit('hide-spinner');
      }
    },

    async runMatrixCalculation(type, specBody) {
      this.bondCashflow = {};
      let cprToPass = [];
      let cdrToPass = [];
      const regex = RegExp('.*[a-zA-Z]+.*');
      for (let i = 0; i < this.matrixCpr.length; i++) {
        if (typeof this.matrixCpr[i] === 'string' && regex.test(this.matrixCpr[i])) {
          if (this.vectors.has(this.matrixCpr[i])) {
            cprToPass.push(this.vectors.get(this.matrixCpr[i]));
          } else {
            this.errorMessage = this.matrixCpr[i] + ' vector was not found.';
            return;
          }
        } else {
          cprToPass.push(this.matrixCpr[i]);
        }
      }

      for (let i = 0; i < this.matrixCdr.length; i++) {
        if (typeof this.matrixCdr[i] === 'string' && regex.test(this.matrixCdr[i])) {
          if (this.vectors.has(this.matrixCdr[i])) {
            cdrToPass.push(this.vectors.get(this.matrixCdr[i]));
          } else {
            this.errorMessage = this.matrixCdr[i] + ' vector was not found.';
            return;
          }
        } else {
          cdrToPass.push(this.matrixCdr[i]);
        }
      }
      try {
        let body = new RequestBodyFactory(
          'BOND',
          {
            dealName: this.dealName,
            bondName: this.bondName,
            settlementDate: this.settlementDate,
            libor: this.libor,
            runLoanLevel: this.$store.getters.useLoanLevel,
            prepaymentModel: this.$store.getters.prepaymentModel,
            cpr: cprToPass,
            cdr: cdrToPass,
            lossSeverity: this.lossSeverity,
            delinquency: this.delinquency,
            tuneCdr: this.tuneCdr,
            tuneSeverity: this.tuneSeverity,
            selectedScenario: this.selectedScenario,
            specBody: specBody,
            cleanupCall: this.$store.getters.cleanupCall
          },
          false
        );
        let typeMatix = type.toLowerCase() + 'Matrix';
        this[typeMatix] = createEmpty2dArray(10);
        this.errorMessage = '';
        setCookies(this);
        this.$emit('show-spinner');
        let matrix = createEmpty2dArray(10);
        let walMatrix = createEmpty2dArray(10);
        let writeDownMatrix = createEmpty2dArray(10);

        if (!isBasicAnalysisBodyValid(body)) {
          this.errorMessage = createBasicValidationErrorMessage(
            body.Cpr,
            body.Cdr,
            body.LossSeverity,
            body.Delinquency,
            body.Libor
          );
          return;
        }
        let start = Date.now();
        var res = await service.runMatirxPiceYieldSpread(
          type,
          body,
          this.$store.getters.useLoanLevel
        );
        let millis = Date.now() - start;
        this.runTime = millis;

        let cprIndex = 0;
        let cdrIndex = 0;
        for (let matrixCdrIndex = 0; matrixCdrIndex < this.matrixCdr.length; matrixCdrIndex++) {
          if (
            this.matrixCdr[matrixCdrIndex] === '' ||
            this.matrixCdr[matrixCdrIndex] == undefined
          ) {
            continue;
          }

          let row = res.data[cdrIndex];

          for (let matrixCprIndex = 0; matrixCprIndex < this.matrixCpr.length; matrixCprIndex++) {
            if (
              this.matrixCpr[matrixCprIndex] === '' ||
              this.matrixCpr[matrixCprIndex] == undefined
            ) {
              continue;
            }

            let column = row[cprIndex];

            let value = '';
            if (column[type].IsSuccessful) {
              let formatFunction = null;
              switch (type) {
                case 'Price':
                  formatFunction = val => formatter.formatDollarValue(val);
                  break;
                case 'Yield':
                  formatFunction = val => formatter.formatPctValue(val, 2);
                  break;
                case 'Spread':
                  formatFunction = val => formatter.round(val, 2);
                  break;
              }
              value = formatFunction(column[type].Value);
            } else {
              value = '-----';
              // TODO sk: remove after redesigning c++ message system
              if (
                column[type].ErrorMessage !== "Can't compute Yield." &&
                column[type].ErrorMessage !== 'Too many tries in Yield calculation.' &&
                column[type].ErrorMessage !== 'Guess is too negative in Yield calculation.' &&
                column[type].ErrorMessage !== "Can't compute Spread." &&
                column[type].ErrorMessage !== 'Too many tries in Spread calculation.'
              ) {
                this.errorMessage = column[type].ErrorMessage;
              }
            }
            matrix[matrixCprIndex][matrixCdrIndex] = value;
            let wal = column.Simulation.BondsCashflows[0].Wal;
            walMatrix[matrixCprIndex][matrixCdrIndex] =
              wal != null ? formatter.round(wal, 2) : '-----';
            let writedownPct = column.Simulation.BondsCashflows[0].WritedownPct;
            writeDownMatrix[matrixCprIndex][matrixCdrIndex] =
              writedownPct != null ? formatter.formatPctValue(writedownPct, 2) : '-----';
            cprIndex++;
          }
          cprIndex = 0;
          cdrIndex++;
        }
        this.$forceUpdate();
        this.forceUpdate = true;
        this[typeMatix] = matrix;
        this.walMatrix = walMatrix;
        this.writeDownMatrix = writeDownMatrix;
        this.$root.$data.setBondAnalysisMatrixResults(
          this.priceMatrix,
          this.yieldMatrix,
          this.spreadMatrix
        );
      } catch (err) {
        this.errorMessage = err.response.data.Message;
        await service.log(TRACE_ERROR, this.errorMessage, err.stack);
        matrix = createEmpty2dArray(10);
        walMatrix = createEmpty2dArray(10);
        writeDownMatrix = createEmpty2dArray(10);
      } finally {
        this.$emit('hide-spinner');
      }
    },
    clearErrorMessage() {
      this.errorMessage = '';
    },
    exportCashflowToExcel() {
      return excelSupport.exportCashflowToExcel(
        this.$store.getters.username,
        this.dealName,
        this.bondName,
        this.settlementDate,
        this.runDate,
        this.selectedScenario ? this.selectedScenario.data : null,
        this.$refs.cashflow.toMatrix()
      );
    }
  },
  components: {
    SingleScenarioResult,
    Matrix,
    Settings,
    Buttons,
    BondCashflow
  }
};

function loadMatrix(root, type) {
  return isNotEmpty2dArray(root.$root.$data.BondAnalysisMatrixResults[type])
    ? root.$root.$data.BondAnalysisMatrixResults[type]
    : createEmpty2dArray(10);
}
function fillMatrixes(...matrixes) {
  for (let matrix of matrixes) {
    for (let i = 0; i < matrix.length; i++) {
      if (matrix[i] == '' || matrix[i] == undefined) {
        matrix[i] = 0;
      }
    }
  }
}
function setDataFromAppData(root) {
  root.priceMatrix = loadMatrix(root, 'price');
  root.yieldMatrix = loadMatrix(root, 'yield');
  root.spreadMatrix = loadMatrix(root, 'spread');
  root.walMatrix = loadMatrix(root, 'wal');
  root.writeDownMatrix = loadMatrix(root, 'writeDown');
  root.singlePrice = root.$root.$data.BondAnalysisSingleResults.price;
  root.singleYield = root.$root.$data.BondAnalysisSingleResults.yield;
  root.singleSpread = root.$root.$data.BondAnalysisSingleResults.spread;
  root.wal = root.$root.$data.BondAnalysisSingleResults.wal;
  root.principalWindow = root.$root.$data.BondAnalysisSingleResults.principalWindow;
  root.writedownPct = root.$root.$data.BondAnalysisSingleResults.writedownPct;
  root.firstLossPeriod = root.$root.$data.BondAnalysisSingleResults.firstLossPeriod;
  root.bondCashflow = root.$root.$data.BondAnalysisSingleResults.cashflow;
}
function setDataFromCookies(root) {
  root.inputPrice = root.$cookies.isKey('inputPrice') ? root.$cookies.get('inputPrice') : 100;
  root.inputYield = root.$cookies.isKey('inputYield') ? root.$cookies.get('inputYield') : '0';
  root.inputSpread = root.$cookies.isKey('inputSpread') ? root.$cookies.get('inputSpread') : 0;
  root.refCurve = root.$cookies.isKey('refCurve') ? root.$cookies.get('refCurve') : '0';
  root.matrixCpr = root.$cookies.isKey('matrixCpr')
    ? JSON.parse(root.$cookies.get('matrixCpr'))
    : [0, 5, 10, 15, 20, 25, 30, 35];
  root.matrixCdr = root.$cookies.isKey('matrixCdr')
    ? JSON.parse(root.$cookies.get('matrixCdr'))
    : [0, 0.25, 0.5, 1, 1.5, 2, 2.5, 3, 5];
}
function setCookies(root) {
  setCookie(root, 'cpr', 'bondCpr');
  setCookie(root, 'cdr', 'bondCdr');
  setCookie(root, 'lossSeverity', 'bondSeverity');
  setCookie(root, 'delinquency', 'bondDelinquency');
  setCookie(root, 'libor', 'bondLibor');
  setCookie(root, 'cpr', 'bondCpr');
  setCookie(root, 'cpr', 'bondCpr');

  if (root.inputYield) {
    root.$cookies.set('inputPrice', root.inputPrice, '10d');
  }
  if (root.inputYield.length) {
    root.$cookies.set('inputYield', root.inputYield, '10d');
  }
  if (root.inputSpread) {
    root.$cookies.set('inputSpread', root.inputSpread, '10d');
  }
  if (root.refCurve.length) {
    root.$cookies.set('refCurve', root.refCurve, '10d');
  }
  if (root.matrixCpr.length) {
    root.$cookies.set('matrixCpr', JSON.stringify(root.matrixCpr), '10d');
  }
  if (root.matrixCdr.length) {
    root.$cookies.set('matrixCdr', JSON.stringify(root.matrixCdr), '10d');
  }
  if (root.hpi != null && root.hpi.length) {
    root.$cookies.set('bondHpi', root.hpi, '10d');
  }
  if (root.NationalUnemploymentForecast != null && root.NationalUnemploymentForecast.length) {
    root.$cookies.set('bondNationalUnemploymentForecast', root.NationalUnemploymentForecast, '10d');
  }
  if (root.hpa != null && root.hpa.length) {
    root.$cookies.set('bondHpa', root.hpa, '10d');
  }
  if (root.twoYrTsy != null && root.twoYrTsy.length) {
    root.$cookies.set('bond2YrTsy', root.twoYrTsy, '10d');
  }
  if (root.tenYrTsy != null && root.tenYrTsy.length) {
    root.$cookies.set('bond10YrTsy', root.tenYrTsy, '10d');
  }
  if (root.tuneCpr.length) {
    root.$cookies.set('bondTuneCpr', root.tuneCpr, '10d');
  }
  if (root.tuneCdr.length) {
    root.$cookies.set('bondTuneCdr', root.tuneCdr, '10d');
  }
  if (root.tuneSeverity.length) {
    root.$cookies.set('bondTuneSeverity', root.tuneSeverity, '10d');
  }
}

function setCookie(root, field, cookieName) {
  if (typeof root[field] === 'object') {
    root.$cookies.set(cookieName, JSON.stringify(root[field]), '10d');
  } else if (root[field].length) {
    root.$cookies.set(cookieName, root[field], '10d');
  }
}
</script>

<style lang="scss" scoped>
table {
  &.color {
    margin-bottom: 0;
    th {
      vertical-align: middle;
    }
  }
  &.no-border {
    th,
    td {
      border: none;
    }
  }
}
.form-control {
  text-align: right;
}
.custom-select {
  border-radius: 0;
}
.no-focus {
  &:focus {
    outline: none;
  }
}
</style>

<style lang="scss">
.modal-lg {
  max-width: 80%;
}
</style>
